const FormHiddenInput = () => (
  <input autoComplete="false" name="hidden" type="text" style={{ display: 'none' }} />
);

export default FormHiddenInput;
